import './App.css';
import Main from './Components/Main/Main';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import { Authenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import { StockProvider } from './Components/Context/StockContext';
// import { ToastContainer, toast } from 'react-toastify';
// import { ToastContainer } from 'react-toastify';

Amplify.configure(awsconfig)

function App() {

  console.log('App component rendered');
  return (

    <Authenticator>
      {({ signOut, user }) => {
        return (
          <div className='App'>

            <StockProvider>
              <Main user={user} signOut={signOut}/>
            </StockProvider>

          </div>
        )
      }}
    </Authenticator>

  );
}

export default App;